
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import '../dhtmlxscheduler_collision.js';
import '../css/new-calendar.css';
import actions from "../js/actions.js";
import URLS from "../js/Urls.js";
export default {
  data() {
    return {
      CleanRooms: {},
      DirtyRooms: {},
      Rooms: {}
    };
  },

  methods: {},
  on: {
    pageInit: async function (e, page) {
      let calendarRangeFrom2;

      let moment = require('moment');

      let today = moment();
      let self = this;

      async function updateUI(date) {
        let RoomsList = await actions.GetKeeperRooms(date);
        let cleanRooms = RoomsList.filter(x => x.SysStatusID === 1);
        let cleanRoomsGroupByFloor = Object.groupBy(cleanRooms, ({
          Floor
        }) => Floor);
        let dirtyRooms = RoomsList.filter(x => x.SysStatusID === 2);
        let dirtyRoomsGroupByFloor = Object.groupBy(dirtyRooms, ({
          Floor
        }) => Floor);
        let allOtherRooms = RoomsList.filter(x => x.SysStatusID !== 1 && x.SysStatusID !== 2);
        let roomsGroupByFloor = Object.groupBy(allOtherRooms, ({
          Floor
        }) => Floor);
        self.$setState({
          CleanRooms: cleanRoomsGroupByFloor,
          DirtyRooms: dirtyRoomsGroupByFloor,
          Rooms: roomsGroupByFloor
        });
      }

      calendarRangeFrom2 = app.f7.calendar.create({
        inputEl: '#plan-calendar-From',
        dateFormat: 'dd/mm/yyyy',
        date: today,
        value: [new Date()],
        closeOnSelect: true,
        on: {
          change: function (c) {
            let CalendarDate = c.value;
            let selectedDate = new Date(CalendarDate[0]);
            updateUI(selectedDate);
          }
        }
      });
      $$('.popup-about').on('popup:open', function (e) {});
    }
  },
  id: '357abe52f0',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page style="background-color: #f7f7f7;" data-name=reservationscalendar><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link icon-only panel-open" data-panel=left><i class="icon f7-icons if-not-md">menu</i> <i class="icon material-icons if-md">menu</i></a></div><div class="title sliding"><input name=checkindate class=dhx_cal_date type=text readonly=readonly id=plan-calendar-From></div></div></div><div class=page-content style=padding-bottom:0px><div class=subnavbar style="background-color: #222933;"><div class=subnavbar-inner><div class=row><div class="segmented segmented-strong" style=background-color:#40454cb8><a class="button tab-link tab-link-active" href=#CleanTab>Clean<span class="badge color-red" style="border-radius: 10px !important;position: absolute;">5</span></a> <a class="button tab-link" href=#DirtyTab>Dirty<span class="badge color-red" style="border-radius: 10px !important;position: absolute;">5</span></a> <a class="button tab-link" href=#DnsTab>Other<span class="badge color-red" style="border-radius: 10px !important;position: absolute;">5</span></a> <span class=segmented-highlight></span></div></div></div></div><div id=tab-2 class=tab><div class=tabs><div class="view tab tab-active" id=CleanTab><!--- Select your room--><div class=chooseroomdiv>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.CleanRooms, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=block-title>';
          r += Template7Helpers.t.call(ctx_2, 'Floor', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          r += c(data_2 && data_2.key, ctx_2);
          r += '</div><div class=block>';
          r += Template7Helpers.each.call(ctx_2, ctx_2, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=row><div class=card data-room-type-id=""><div class="card-content card-content-padding takis popup-open" data-popup=.popup-about><div class=row><div class="col-55 flex" id=""><span><b>Room: ';
              r += c(ctx_3.RoomName, ctx_3);
              r += '</b></span> <span>';
              r += c(ctx_3.Status, ctx_3);
              r += '</span></div><div class="col-30 flex room-price-cnt" style="align-items: flex-end;"><span class="badge custom-badge">';
              r += c(ctx_3.ExtraInfo, ctx_3);
              r += '</span> <span class="color-darkgreen roomprice" style="text-align: center; font-size: 20px;"><b>';
              r += c(ctx_3.Housekeeper, ctx_3);
              r += '</b></span></div></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class="view tab" id=DirtyTab><!--- Select your room--><div class=chooseroomdiv>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.DirtyRooms, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=block-title>';
          r += Template7Helpers.t.call(ctx_2, 'Floor', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          r += c(data_2 && data_2.key, ctx_2);
          r += '</div><div class=block>';
          r += Template7Helpers.each.call(ctx_2, ctx_2, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=row><div class=card data-room-type-id=""><div class="card-content card-content-padding takis popup-open" data-popup=.popup-about><div class=row><div class="col-55 flex" id=""><span><b>Room: ';
              r += c(ctx_3.RoomName, ctx_3);
              r += '</b></span> <span>';
              r += c(ctx_3.Status, ctx_3);
              r += '</span></div><div class="col-30 flex room-price-cnt" style="align-items: flex-end;"><span class="badge custom-badge">';
              r += c(ctx_3.ExtraInfo, ctx_3);
              r += '</span> <span class="color-darkgreen roomprice" style="text-align: center; font-size: 20px;"><b>';
              r += c(ctx_3.Housekeeper, ctx_3);
              r += '</b></span></div></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class="view tab" id=DnsTab><!--- Select your room--><div class=chooseroomdiv>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Rooms, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=block-title>';
          r += Template7Helpers.t.call(ctx_2, 'Floor', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          r += c(data_2 && data_2.key, ctx_2);
          r += '</div><div class=block>';
          r += Template7Helpers.each.call(ctx_2, ctx_2, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=row><div class=card data-room-type-id=""><div class="card-content card-content-padding takis popup-open" data-popup=.popup-about><div class=row><div class="col-55 flex" id=""><span><b>Room: ';
              r += c(ctx_3.RoomName, ctx_3);
              r += '</b></span> <span>';
              r += c(ctx_3.Status, ctx_3);
              r += '</span></div><div class="col-30 flex room-price-cnt" style="align-items: flex-end;"><span class="badge custom-badge">';
              r += c(ctx_3.ExtraInfo, ctx_3);
              r += '</span> <span class="color-darkgreen roomprice" style="text-align: center; font-size: 20px;"><b>';
              r += c(ctx_3.Housekeeper, ctx_3);
              r += '</b></span></div></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class="popup popup-about"><div><div style="display: flex;align-items: center;justify-content: space-between;border-bottom: groove;width: 100%;"><p><a class="link popup-close" href=#><i class=f7-icons>arrow_left</i></a></p><div style="display: flex; justify-content: flex-end; justify-content: space-evenly; width: 100%;"><div><div style="font-size: 24px;\n                                        color: black;\n                                        font-weight: 600;">Room 222</div><div style="font-size: 13px;\n                                        font-weight: 500;\n                                        color: darkgray;">not occupied</div></div><div style="background-color: gray;height: 40px;width: 2px;"></div><div style="flex-direction: column;\n                                    align-items: flex-start;"><div style="font-size: 17px;\n                                        font-weight: 500;\n                                        color: darkgray;">pinelopi</div><div style="display: flex;"><div><i class=f7-icons>person_fill</i> <i class=f7-icons>person_fill</i></div><div style="background-color: blue;height: auto;width: 2px;"></div><div><i class=f7-icons>person</i></div></div></div></div></div><div style="display: flex;\n                            flex-direction: column;\n                            align-items: center;\n                            border-bottom: groove;"><div style="font-size: 18px;\n                                font-weight: 500;">5/5 nights</div><div style="background-color: black;height: 5px;width: 100%;border-radius: 5px;"></div><div style="display: flex;\n                                width: 100%;\n                                justify-content: space-between;"><div style="display: flex;\n                                    align-items: center;"><i class=f7-icons>square_arrow_right</i>22 july 2024</div><div style="display: flex;\n                                    align-items: center;">22 july 2024<i class=f7-icons>square_arrow_right</i></div></div></div><div style="border-bottom: groove;display: flex;align-items: center;"><div style="font-size: 30px;transform: translate(-50%);left: 50%;position: relative;"><span style="font-size: 45px;font-weight: 500;">00:00:00</span></div></div><div style="border-bottom: groove;"><div style="display: flex;\n                                justify-content: space-between;\n                                margin: 20px;"><div style="display: flex; align-items: center; flex-direction: row;"><i class=f7-icons>nosign</i> <span style="font-size: 17px;">Do not Disturb</span></div><label class="toggle toggle-init color-black"><input type=checkbox checked=checked> <span class=toggle-icon></span></label></div></div><div class=list style="border-bottom: groove;"><ul><li style="width: 90%;\n                                    background: #FFDBDF;\n                                    border-radius: 10px;\n                                    left: 50%;\n                                    transform: translate(-50%);\n                                    margin-bottom: 10px;"><label class="item-radio item-radio-icon-end item-content"><input type=radio name=demo-radio-end value=Books checked=checked> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Dirty</div></div></label></li><li style="width: 90%;\n                                    background: #F8F2D2;\n                                    border-radius: 10px;\n                                    left: 50%;\n                                    transform: translate(-50%);\n                                    margin-bottom: 10px;"><label class="item-radio item-radio-icon-end item-content"><input type=radio name=demo-radio-end value=Movies> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Cleaning / In Progress</div></div></label></li><li style="width: 90%;\n                                    background: #E4F4F4;\n                                    border-radius: 10px;\n                                    left: 50%;\n                                    transform: translate(-50%);\n                                    margin-bottom: 10px;"><label class="item-radio item-radio-icon-end item-content"><input type=radio name=demo-radio-end value=Food> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Clean</div></div></label></li><li style="width: 90%;\n                                    background: #DDDEFA;\n                                    border-radius: 10px;\n                                    left: 50%;\n                                    transform: translate(-50%);\n                                    margin-bottom: 10px;"><label class="item-radio item-radio-icon-end item-content"><input type=radio name=demo-radio-end value=Drinks> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Done / Inspected</div></div></label></li></ul></div><div style="border-bottom: groove;"><div style="display: flex;justify-content: space-between;"><div style="display: flex;align-items: center;"><i class=f7-icons>exclamationmark_triangle_fill</i> <span style="font-size: 18px;font-weight: 500;margin: 10px;">Report a Problem</span></div><i class=f7-icons>chevron_right</i></div></div><div style="margin: 10px;"><span style="font-size: 20px;">Notes Housekeeping</span><div class="card reservationcardbtn" style="border: solid;border-width: thin;border-radius: 10px;"><div class="card-content card-content-padding"><li class=item-content style="display: block;padding-top: 5px;padding-bottom: 5px;"><div class=row><div class=col-70 style="font-weight:600;font-size: 15px;">Room Cleaning</div><div class=col-30 id=roomNumberID><div style="display: flex;flex-direction: column;"><span>RoomName</span> <span>added 15:08</span></div></div></div><div class=row><div class="col-100 reservcode" style=display:flex;>Res. cod.</div></div></li></div></div></div></div></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
    .dhx_cal_container {
        font-family: 'Open Sans';
    }

    #plan-calendar-From {
        height: 40px;
        border: none;
        /* text-align: center; */
        font-size: 16px;
        padding-left: 10px;
    }

    .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 18px 0 0;
    }

    .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 18px;
    }



    .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 18px 0 0;
    }

    .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
    .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
    .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 18px;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 7px 0 0;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 7px;
    }

    @media(max-width:1440px) {

        .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
        .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 9px 0 0;
        }

        .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
        .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
        .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 9px;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 5px 0 0;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 5px;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 7px 0 0;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 7px;
        }
    }

    .CustEventShape_1 .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_1 .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 18px 0 0;
        border-bottom-color: transparent !important;
        border-right-color: transparent !important;
        border-left-color: transparent !important;
    }

    .CustEventShape_1 .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .CustEventShape_1 .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 18px;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        border-left-color: transparent !important;
    }

    .CustEventShape_2 .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_2 .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 0 30px 18px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
    }

    .CustEventShape_2 .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_CheckOutToday.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.event_Paid.schType_Reservation:before,
    .CustEventShape_2 .dhx_cal_event_line.schType_undefined:before {
        border-width: 30px 18px 30px 0;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        border-left-color: transparent !important;
    }

    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.schType_undefined:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after {
        border-width: 30px 0 30px 34px;
        right: -35px;
    }

    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_week_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 30px 34px 30px 0;
        left: -35px;
    }

    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after {
        border-width: 30px 0 30px 13px;
        right: -14px;
    }

    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
    .CustEventShape_2 .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 30px 13px 30px 0;
        left: -14px;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
        border-width: 30px 7px 0 0;
    }

    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
    .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
        border-width: 0px 0px 30px 7px;
    }

    @media(max-width:1440px) {

        .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 9px 0 0;
        }

        .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 9px;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 5px 0 0;
        }

        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 5px;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:after {
            border-width: 30px 7px 0 0;
        }

        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .divOpen .dhx_scheduler_month_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 0px 0px 30px 7px;
        }

        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.schType_undefined:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Cancelled.schType_Reservation:after,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_NoShow.schType_Reservation:after {
            border-width: 30px 0 30px 15px;
            right: -16px;
        }

        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Confirmed.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_Unconfirmed.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedIn.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.event_CheckedOut.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_CheckOutToday.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Paid.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.EC_Deposit.schType_Reservation:before,
        .CustEventShape_2 .dhx_scheduler_two_week_timeline .dhx_cal_event_line.schType_undefined:before {
            border-width: 30px 15px 30px 0;
            left: -16px;
        }
    }

    .EC_Deposit .schdResIcons:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, 0.4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 50%;
        top: 0;
        content: "";
    }

    .EC_Paid .schdResIcons:after {
        background: repeating-linear-gradient(135deg, rgba(0, 0, 0, 0.4), transparent 3px, transparent 9px, transparent 9px);
        position: absolute;
        left: 0;
        height: 100%;
        width: 100%;
        top: 0;
        content: "";
    }

    .subnavbar {
        position: fixed;
        z-index: 9000;
    }

    .row .col-30 {
        --f7-cols-per-row: none;
    }
`,
  styleScoped: false
};
    